import type React from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import useConfig from 'app/config';

import Typography from 'app/ui/components/atoms/typography';
import ResourceListGrid from 'app/ui/components/molecules/resource-list-card/grid';
import Loading from 'app/ui/components/molecules/loading';

import { GetRootResourceList } from 'app/pages/resource-lists-home/root-resource-list.gql';
import type { GetRootResourceListQuery, GetRootResourceListQueryVariables } from 'app/types/graphql';
import { useIntl } from 'react-intl';

const Container = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing(20)};
  margin-bottom: ${({ theme }) => theme.spacing(14)};
`;

const Title = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(6)};
`;

type MoreResourceContentProps = {
  limit?: number;
  className?: string;
};

const MoreResourceContent: React.FC<MoreResourceContentProps> = ({ limit = 3, className }) => {
  const { config } = useConfig();
  const intl = useIntl();

  const { data, loading, error } = useQuery<GetRootResourceListQuery, GetRootResourceListQueryVariables>(
    GetRootResourceList,
    {
      variables: { resourceListId: config.REACT_APP_ROOT_RESOURCE_LIST_ID },
    },
  );

  if (loading) {
    return <Loading />;
  }

  if (error || !data || !data.resourceListById || data.resourceListById.resourceLists?.length === 0) {
    return null;
  }

  const moreResources = intl.formatMessage({ id: 'resources.more' });

  return (
    <Container className={className}>
      <Title>
        <Typography variant="h3" color="white">
          {moreResources}
        </Typography>
      </Title>
      <ResourceListGrid resourceLists={data.resourceListById.resourceLists?.slice(0, limit) || []} />
    </Container>
  );
};

export default MoreResourceContent;
